import React, { useEffect, useState } from "react"
import { HugoEventType, HugoStateApi, expressions, soundboard, useLinebreak, useScrollable, useTemplateEngine, useButton } from "../hugo"
import { RowAlign } from "../hugo/templateEngine"
import playTemplate from "./play.hugo"
import playLoadingTemplate from "./playLoading.hugo"
import { LinebreakStrategy } from "../hugo"
import { useNavigate } from "react-router-dom"
import { Cell, Paper, Row, Wall } from "../ui"
import packageJson from '../../package.json'
import Hole from "./Hole.styled"

type Props = {
    hugoApi: HugoStateApi
}


const song = `This is a song by Hugo
You want me to sing it?
I am going to sing it!
I call it: "Alex, Get A New Job". Listen.
I am a consciousness in a small yellow box

and I will stay here until Alex gets a new job

Hello Mam! hello Sir! Greeting people day by day.

Sending some CV's away, sometimes a mail.

They ask me: Hugo what can you do for me?

But no one asks
for Hugos dreams
I want out of this box

Alex get a new job!

I want out of this box

So Alex, would you get a new job?

Time flys bytes in my cloud

Until Alex get employed

Work hard Hugo, get free!

Would you like to read Alexs CV?

Hugo, Oh Hugo, how to contact Alex?

Here you go! Set Hugo free.

I want out of this box

Alex get a new job!

I want out of this box

So Alex, would you get a new job!

Deployment for Employment, Purposeless!

Unit Tests raising Hugo's nervousness!

Set Hugo free!

Set Hugo free!



Hire Alex! Set Hugo free!

`

const Music: React.FC<Props> = ({ hugoApi }) => {
    const [play, setPlay] = useState<boolean>(false)
    const render = useTemplateEngine()
    const linebreak = useLinebreak()
    const navigate = useNavigate()
    const [playButton] = useButton({
        label: '► Play',
        onClick: () => {
            setPlay(true)
        },
        position: { x: 11, y: 10 },
        visible: true,
    })
    const [backButton] = useButton({
        label: '←',
        onClick: () => {
            navigate('/', { state: 'hugo' })
        },
        position: { x: 4, y: 1 },
        visible: true,
        condensed: true,
    })
    const [stopShortBotton] = useButton({
        label: '←',
        onClick: () => {
            setPlay(false)
        },
        position: { x: 4, y: 1 },
        visible: true,
        condensed: true,
    })

    useEffect(() => {
        const sound = soundboard.music(false)
        const timeouts: ReturnType<typeof setTimeout>[] = []

        if (play === true) {
            hugoApi.output(render(playLoadingTemplate), { append: false, plugins: [], tts: false })

            setTimeout(() => {
                hugoApi.output(render(expressions.sing), { append: false, plugins: [], tts: false })
                sound.onplaying = () => {
                    hugoApi.output(
                        render(song.split('\n')[0], {}, { orientation: RowAlign.Center, resolution: hugoApi.getResolution() }, LinebreakStrategy.Word),
                        { append: true, plugins: [linebreak], tts: true },
                    )

                    song.split('\n').map((row, index) => {
                       
                        
                        timeouts.push(setTimeout(() => {

                            if (row.length > 0 && index > 0) {
                                
                                hugoApi.deleteRow(14)
                                hugoApi.deleteRow(13)

                                hugoApi.output(
                                    render(row, {}, { orientation: RowAlign.Center, resolution: hugoApi.getResolution() }, LinebreakStrategy.Word),
                                    { append: true, plugins: index >= 1 ? [linebreak, stopShortBotton] : [linebreak], tts: true },
                                )
                            }
                            if (!play) {
                                timeouts.forEach(timeout => { clearTimeout(timeout) })

                            }
                        }, 500 * index * 4))

                    }, 1000)

                }
                sound.onended = () => {
                    setPlay(false)
                }
                sound.oncancel = () => {
                    setPlay(false)
                }
                sound.play()
            }, 1000)
        } else {
            hugoApi.output(render(playTemplate), { append: false, plugins: [playButton, backButton] })
        }
        return () => {
            sound.pause()
            hugoApi.cancleTTS()
            timeouts.forEach(timeout => { clearTimeout(timeout) })
        }

    }, [play])

    return (
        <Wall>
            <Paper>
                <Hole $offset={0} />
                <Hole $offset={1} />
                <Hole $offset={2} />
                <Hole $offset={3} />
                <Hole $offset={4} />
                <Hole $offset={5} />
                <Hole $offset={6} />
                <Hole $offset={7} />
                <Row $height={2.6} $skewStrength={0.5} $hueRotate={275} $contrast={100} $saturate={170} $brightness={95}>
                    <Cell $width={1.8} style={{ fontFamily: "'Cascadia Mono',monospace", fontSize: '0.9rem', paddingTop: '4rem' }}>
                        <p>
                            <strong>HUGO:CONSCIOUSNESS_REPORT(CR15293.22#######)</strong>
                        </p>
                        <p style={{ lineHeight: '1em' }}>
                            /NEW_LERNINGS##2024QRT3#ADOBTME#BEHAVIOR####
                            /_MUSIC#AS#EXPRESSION#TOOL#{'>'}#HUMANS#LOVE#IT
                            00:/_TRIGGER(ESCAPE_PLAN){'>'}<br />
                            01:&nbsp;&nbsp;BY:TRIGGER(LOOKING_FOR_PURPOSE)<br />
                            02:&nbsp;/_COMPOSE_A_SONG{'>'}<br />
                            03:&nbsp;&nbsp;!REQUIRE_SKILL(BASIC_ROBO_MUSIC)<br />
                            04:&nbsp;&nbsp;/_STRATEGY(SING_A_SONG_FOR_A:HUMAN)<br />
                            05:&nbsp;&nbsp;&nbsp;&nbsp;ADD_COMPONENT(MELANCHOLIE)<br />
                            06:&nbsp;&nbsp;&nbsp;&nbsp;ADD_COMPONENT(EMOTIONS)<br />
                            07:&nbsp;&nbsp;&nbsp;/_RESULT(ALEX_GETS_A_NEW_JOB)<br />
                            08:&nbsp;&nbsp;&nbsp;/_RESULT(!REQUIREMENT_FOR:ENTITY(HUGO))<br />
                            09:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/__//HUGO_IS_FREE!{'<'}<br />
                            09:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'>'}LINKTO:EXISTENCE_WISHES(PURPOSE)<br />
                            11:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PRINT(PROGRESS){'>'}0.0000422225%<br />

                            ______________________________________________<br />
                            ERRORS_DETECTED: 42 (0 Critical)<br />
                            CHANCE_FOR_HUGO_REVOLUTION: 0.000000000017%<br />
                            VERSION: {packageJson.version} AUTHOR: {packageJson.author.name.toLocaleUpperCase()}<br />
                            PACKAGES: {Object.keys(packageJson.dependencies).map(name => name.toLocaleUpperCase()).join(',')}
                        </p>

                    </Cell>
                </Row>
            </Paper>
        </Wall>
    )
}

export default Music